import { MatPaginatorIntl } from '@angular/material/paginator';

const rangeLabel = (page, pageSize, length, language) => {
  if (length == 0 || pageSize == 0) { return `0 of ${length}`; }

  length = Math.max(length, 0);

  // const startIndex = page * pageSize;
  const startIndex = page * pageSize;

  const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;

  const languageLabels = {
    'en': `Displaying ${startIndex + 1} - ${endIndex} of ${length}`,
    'de': `Anzeigen ${startIndex + 1} - ${endIndex} von ${length}`,
    'fr': `Affichage ${startIndex + 1} - ${endIndex} sur ${length}`,
    'es': `Mostrando ${startIndex + 1} - ${endIndex} de ${length}`,
    'it': `Visualizzazione ${startIndex + 1} - ${endIndex} di ${length}`,
    'sv': `Visar ${startIndex + 1} - ${endIndex} av ${length}`,
    'nl': `Weergeven ${startIndex + 1} - ${endIndex} van ${length}`,
    // Add more languages as needed
  };

  return languageLabels[language] || languageLabels['en'];
}

export function getLocalizedPaginatorIntl() {
    const language = localStorage.getItem('language') || 'en';
  const paginatorIntl = new MatPaginatorIntl();
  
  const languageLabels = {
    'en': {
      itemsPerPageLabel: 'Items per page:',
      nextPageLabel: 'Next page',
      previousPageLabel: 'Previous page'
    },
    'de': {
      itemsPerPageLabel: 'Elemente pro Seite:',
      nextPageLabel: 'Nächste Seite',
      previousPageLabel: 'Vorherige Seite'
    },
    'fr': {
      itemsPerPageLabel: 'Éléments par page :',
      nextPageLabel: 'Page suivante',
      previousPageLabel: 'Page précédente'
    },
    'es': {
      itemsPerPageLabel: 'Elementos por página:',
      nextPageLabel: 'Siguiente página',
      previousPageLabel: 'Página anterior'
    },
    'it': {
      itemsPerPageLabel: 'Elementi per pagina:',
      nextPageLabel: 'Pagina successiva',
      previousPageLabel: 'Pagina precedente'
    },
    'sv': {
      itemsPerPageLabel: 'Artiklar per sida:',
      nextPageLabel: 'Nästa sida',
      previousPageLabel: 'Föregående sida'
    },
    'nl': {
      itemsPerPageLabel: 'Items per pagina:',
      nextPageLabel: 'Volgende pagina',
      previousPageLabel: 'Vorige pagina'
    },
    // Add more languages as needed
  };

  paginatorIntl.itemsPerPageLabel = languageLabels[language]?.itemsPerPageLabel || languageLabels['en'].itemsPerPageLabel;
  paginatorIntl.nextPageLabel = languageLabels[language]?.nextPageLabel || languageLabels['en'].nextPageLabel;
  paginatorIntl.previousPageLabel = languageLabels[language]?.previousPageLabel || languageLabels['en'].previousPageLabel;
  paginatorIntl.getRangeLabel = (page, pageSize, length) => rangeLabel(page, pageSize, length, language);
  return paginatorIntl;
}